import clsx from 'clsx';
import React, { Fragment } from 'react';
import { InfiniteData } from 'react-query';

import { subscriber_profile_path } from '@routes';
import { FollowType } from '@utils/backend-api/follow';
import {
  FOLLOWER,
  FOLLOWING,
  PaginatedFollowers,
  PaginatedFollowings,
} from '@utils/backend-api/subscriber_directory';

import FollowButton from '../FollowButton';
import TIModal from '../TIModal';
import styles from './styles.module.scss';

interface FollowModalProps {
  currentActiveTab: string;
  currentActiveList: InfiniteData<PaginatedFollowers | PaginatedFollowings>;
  clickHandler: (tabName: string, updateModalStatus?: boolean) => void;
  handlePageChange: () => void;
  hasNextPage: boolean;
  isLoading: boolean;
  isModalOpen: boolean;
  setIsModalOpen: (status: boolean) => void;
  totalFollowers: number;
  totalFollowing: number;
  username: string;
}

const FollowModal = ({
  currentActiveTab,
  currentActiveList,
  clickHandler,
  isLoading,
  isModalOpen,
  handlePageChange,
  hasNextPage,
  setIsModalOpen,
  totalFollowers,
  totalFollowing,
  username,
}: FollowModalProps) => {
  const handleOnScroll = (e) => {
    if (!hasNextPage) return;
    const scrollPos = e.target.scrollTop + e.target.clientHeight;
    if (scrollPos >= e.target.scrollHeight) handlePageChange();
  };

  const hasPages = currentActiveList?.pages && Object.keys(currentActiveList.pages[0]).length > 0;

  return (
    <TIModal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(!isModalOpen)}
      parentClass={styles.followMemberList}
      disableScrollLock={false}
    >
      <div className={styles.headerWrapper}>
        <div className={styles.headerContainer}>
          {totalFollowers > 0 && (
            <div
              className={clsx(styles.header, {
                [styles.activeTab]: currentActiveTab === FOLLOWER,
                [styles.disabled]: totalFollowers <= 0,
              })}
              onClick={() => clickHandler(FOLLOWER)}
            >
              <span className={styles.number}>{totalFollowers}</span> Followers
            </div>
          )}
          {totalFollowers > 0 && totalFollowing > 0 && <div className={styles.hrLine}>|</div>}
          {totalFollowing > 0 && (
            <div
              className={clsx(styles.header, {
                [styles.activeTab]: currentActiveTab == FOLLOWING,
                [styles.disabled]: totalFollowing <= 0,
              })}
              onClick={() => clickHandler(FOLLOWING)}
            >
              <span className={styles.number}>{totalFollowing}</span> Following
            </div>
          )}
        </div>
      </div>
      <div
        className={styles.listContainer}
        onScroll={handleOnScroll}
        data-testid="follow-list-container"
      >
        {hasPages &&
          currentActiveList?.pages.map((group, i) => (
            <Fragment key={i}>
              {group[currentActiveTab === FOLLOWER ? 'followers' : 'following'].map((member) => (
                <div
                  className={styles.memberContainer}
                  key={member.username}
                  data-testid="follow-list-member"
                >
                  <div
                    className={styles.memberWrapper}
                    onClick={() =>
                      (window.location = subscriber_profile_path({ username: member.username }))
                    }
                  >
                    <img className={styles.avatar} src={member.pictureUrl} />
                    <div className={styles.memberDetail}>
                      <div className={styles.name}>{member.name}</div>
                      <div className={styles.detail}>
                        {member.companyName}
                        {member.companyName && member.titleAtCompany && (
                          <div className={styles.dotMiddle}>.</div>
                        )}
                        <div className={styles.company_name}>{member.titleAtCompany}</div>
                      </div>
                    </div>
                  </div>
                  {member.canFollow && (
                    <div className={styles.followBtn}>
                      <FollowButton
                        followStatus={member.followStatus}
                        followeeId={member.identityId}
                        followType={FollowType.Identity}
                        username={username}
                      />
                    </div>
                  )}
                </div>
              ))}
            </Fragment>
          ))}

        {isLoading && 'Loading …'}
      </div>
    </TIModal>
  );
};

export default FollowModal;
